import {
  Module,
  VuexModule,
  Mutation,
  getModule,
} from "vuex-module-decorators";

import store from "@/store";

const name = "sessionCache";

if (store.state[name]) {
  store.unregisterModule(name);
}

export interface SessionCacheKeyValue {
  key: string;
  value: string | null | undefined;
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class SessionCacheVuexModule extends VuexModule {
  cache = new Map<string, string | null | undefined>();

  @Mutation
  setValue(keyValue: SessionCacheKeyValue) {
    const { key, value } = keyValue;

    this.cache.set(key, value);
  }

  get value(): (key: string) => string | null | undefined {
    return (key: string) => {
      return this.cache.get(key);
    };
  }

  @Mutation
  clear() {
    this.cache.clear();
  }
}

export const SessionCacheModule = getModule(SessionCacheVuexModule, store);
